// extracted by mini-css-extract-plugin
var _1 = "SummaryStats__blockStar--Kr4hf";
var _2 = "SummaryStats__blockStars--rmHRn";
var _3 = "SummaryStats__blockTrophy--EiRdg";
var _4 = "SummaryStats__expand--nENqJ";
var _5 = "SummaryStats__extraSpace--vwPCT";
var _6 = "SummaryStats__hide--Pri7M";
var _7 = "SummaryStats__main--U_jzp";
var _8 = "SummaryStats__schoolStat--HXUBY SummaryStats__stat--DI_l9";
var _9 = "SummaryStats__singleTrophy--_1JJh";
var _a = "SummaryStats__star--cVcgi SummaryStats__stat--DI_l9";
var _b = "SummaryStats__starSet--Lqeo8 SummaryStats__star--cVcgi SummaryStats__stat--DI_l9";
var _c = "SummaryStats__stat--DI_l9";
var _d = "SummaryStats__time--TEB0W SummaryStats__stat--DI_l9";
var _e = "SummaryStats__timeText--HVgJ0 SummaryStats__time--TEB0W SummaryStats__stat--DI_l9";
var _f = "SummaryStats__trophy--toucF SummaryStats__stat--DI_l9";
var _10 = "SummaryStats__trophyOuter--OPhy0";
var _11 = "SummaryStats__xp--YVBKN SummaryStats__stat--DI_l9";
var _12 = "SummaryStats__xpText--Qd66D SummaryStats__xp--YVBKN SummaryStats__stat--DI_l9";
export { _1 as "blockStar", _2 as "blockStars", _3 as "blockTrophy", _4 as "expand", _5 as "extraSpace", _6 as "hide", _7 as "main", _8 as "schoolStat", _9 as "singleTrophy", _a as "star", _b as "starSet", _c as "stat", _d as "time", _e as "timeText", _f as "trophy", _10 as "trophyOuter", _11 as "xp", _12 as "xpText" }
